import { useCallback } from 'react'

import { getCopyContentWithoutCitations } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/utils'

import { addToast } from '../../../store/toast/toastSlice'
import { useAppDispatch } from '../../../store/hooks'

import { AIAgentResultState } from '../EditableAIAgentResult/EditableAIAgentResult'

import { extendCopyContentWithComplianceMessage, TEXT_TYPE, writeCopyContentToClipboard } from '../../../common/copy'
import { decorateEmailWithCompliance } from '../../../common/useMailtoDecorateWithCompliance'
import { useEffectiveConfig } from '../../../common/useEffectiveConfig'

interface UseAIAgentResultCopyProps {
  aiAgentResultState: AIAgentResultState
}

export const useAIAgentResultCopy = ({ aiAgentResultState }: UseAIAgentResultCopyProps) => {
  const dispatch = useAppDispatch()

  const { emailComplianceMessage, copyComplianceMessage, accountIsFetching } = useEffectiveConfig()

  const handleCopy = useCallback(async () => {
    if (accountIsFetching) {
      return
    }

    const editorContent = getCopyContentWithoutCitations(aiAgentResultState.editorState)
    if (!editorContent) {
      return
    }

    const copyContent = extendCopyContentWithComplianceMessage(editorContent, copyComplianceMessage)

    await writeCopyContentToClipboard(copyContent)

    dispatch(addToast({ variant: 'info', title: 'Copied', messages: ['Copied to Clipboard!'] }))
  }, [aiAgentResultState, accountIsFetching, copyComplianceMessage, dispatch])

  const handleMailToClicked = useCallback(() => {
    if (accountIsFetching) {
      return
    }
    const editorContent = getCopyContentWithoutCitations(aiAgentResultState.editorState)
    if (!editorContent) {
      return
    }

    const body = decorateEmailWithCompliance(editorContent[TEXT_TYPE], emailComplianceMessage)

    window.location.href = `mailto:?body=${encodeURIComponent(body)}`
  }, [aiAgentResultState, accountIsFetching, emailComplianceMessage])

  return {
    handleCopy,
    handleMailToClicked,
  }
}
